import React from "react";
import Navbar from "./Navbar";
import "./About.css";

function About() {
  return (
    <div id="about_us">
      <Navbar />
      <div>
        <h1>About Us</h1>
      </div>
    </div>
  );
}

export default About;
